import { Component } from "react";
import axios from "axios";
import simplyContext from "../../../../settings/state/simply";
import withRouter from "../../../main/withRouter";
import { funcNavigate } from "../../../../settings/utils/functions";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { header } from "../../components/header";
import { footer } from "../../components/footer";
import { toastAlerts } from "../../../../settings/utils/toastify";
import { BASE_URL, TIMEOUT } from "../../../../settings/utils/config";
import SearchableSelect from "../../../components/searchableSelect/SearchableSelect";

const JOB_CHOICES = [
    { value: "other", label: "سایر" },
    { value: "student", label: "دانشجو" },
    { value: "faculty", label: "هیئت علمی" },
];

const MOASSESE_CHOICES = [
    { value: "other", label: "سایر" },
    { value: "tehran", label: "دانشگاه علوم پزشکی تهران" },
    { value: "beheshti", label: "دانشگاه علوم پزشکی شهید بهشتی" },
    { value: "iran", label: "دانشگاه علوم پزشکی ایران" },
    { value: "isfahan", label: "دانشگاه علوم پزشکی اصفهان" },
    { value: "shiraz", label: "دانشگاه علوم پزشکی شیراز" },
    { value: "tabriz", label: "دانشگاه علوم پزشکی تبریز" },
    { value: "mashhad", label: "دانشگاه علوم پزشکی مشهد" },
    { value: "ahvaz", label: "دانشگاه علوم پزشکی جندی‌شاپور اهواز" },
    { value: "kerman", label: "دانشگاه علوم پزشکی کرمان" },
    { value: "mazandaran", label: "دانشگاه علوم پزشکی مازندران" },
    { value: "baqiyatallah", label: "دانشگاه علوم پزشکی بقیةالله" },
    { value: "yazd", label: "دانشگاه علوم پزشکی شهید صدوقی یزد" },
    { value: "kermanshah", label: "دانشگاه علوم پزشکی کرمانشاه" },
    { value: "urmia", label: "دانشگاه علوم پزشکی ارومیه" },
    { value: "zahedan", label: "دانشگاه علوم پزشکی زاهدان" },
    { value: "kashan", label: "دانشگاه علوم پزشکی کاشان" },
    { value: "babol", label: "دانشگاه علوم پزشکی بابل" },
    { value: "hamedan", label: "دانشگاه علوم پزشکی همدان" },
    { value: "qazvin", label: "دانشگاه علوم پزشکی قزوین" },
    { value: "golestan", label: "دانشگاه علوم پزشکی گلستان" },
    { value: "arak", label: "دانشگاه علوم پزشکی اراک" },
    { value: "gilan", label: "دانشگاه علوم پزشکی گیلان" },
    { value: "zanjan", label: "دانشگاه علوم پزشکی زنجان" },
    { value: "rafsanjan", label: "دانشگاه علوم پزشکی رفسنجان" },
    { value: "shahed", label: "دانشگاه علوم پزشکی شاهد" },
    { value: "lorestan", label: "دانشگاه علوم پزشکی لرستان" },
    { value: "hormozgan", label: "دانشگاه علوم پزشکی هرمزگان" },
    { value: "semnan", label: "دانشگاه علوم پزشکی سمنان" },
    { value: "birjand", label: "دانشگاه علوم پزشکی بیرجند" },
    { value: "ardabil", label: "دانشگاه علوم پزشکی اردبیل" },
    { value: "shahrekord", label: "دانشگاه علوم پزشکی شهرکرد" },
    { value: "north-khorasan", label: "دانشگاه علوم پزشکی خراسان شمالی" },
    { value: "ilam", label: "دانشگاه علوم پزشکی ایلام" },
    { value: "bushehr", label: "دانشگاه علوم پزشکی بوشهر" },
    { value: "kurdistan", label: "دانشگاه علوم پزشکی کردستان" },
    { value: "qom", label: "دانشگاه علوم پزشکی قم" },
    { value: "yasuj", label: "دانشگاه علوم پزشکی یاسوج" },
    { value: "gonabad", label: "دانشگاه علوم پزشکی گناباد" },
    { value: "jahrom", label: "دانشگاه علوم پزشکی جهرم" },
    { value: "shahroud", label: "دانشگاه علوم پزشکی شاهرود" },
    { value: "army", label: "دانشگاه علوم پزشکی ارتش" },
    { value: "sabzevar", label: "دانشگاه علوم پزشکی سبزوار" },
    { value: "zabol", label: "دانشگاه علوم پزشکی زابل" },
    { value: "fasa", label: "دانشگاه علوم پزشکی فسا" },
    { value: "alborz", label: "دانشگاه علوم پزشکی البرز" },
    { value: "torbat", label: "دانشگاه علوم پزشکی تربت حیدریه" },
    { value: "jiroft", label: "دانشگاه علوم پزشکی جیرفت" },
    { value: "dezful", label: "دانشگاه علوم پزشکی دزفول" },
    { value: "ministry-science", label: "وزارت علوم" },
];

class Signup extends Component {
    static contextType = simplyContext;

    state = {
        password: "",
        password2: "",
        firstName: "",
        lastName: "",
        phoneNumber: "",
        email: "",
        codeMelli: "",
        jobs: "",
        jobsOther: "",
        moassese: "",
        moasseseOther: "",
        website: "",
        errors: {},
        generalError: "",
        loading: false,
        checkingAuth: true,
    };

    componentDidMount() {
        window.scrollTo(0, 0);

        const token = sessionStorage.getItem("authorization");

        if (token) {
            this.context.fPreloader(true);
            this.context.fNavigate("/profile");
        } else {
            this.context.fPreloader(false);
            this.setState({ checkingAuth: false });
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        funcNavigate(this.props.navigate, this.context);
    }

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState((prev) => {
            const next = {
                [name]: value,
                errors: { ...prev.errors, [name]: "" },
            };
            if (name === "jobs" && value !== "other") next.jobsOther = "";
            if (name === "moassese" && value !== "other") next.moasseseOther = "";
            return next;
        });
    };

    validate = () => {
        const {
            password, password2,
            firstName, lastName, phoneNumber,
            email, codeMelli, jobs, jobsOther,
            moassese, moasseseOther,
        } = this.state;
        const errors = {};

        if (!password.trim()) errors.password = "کلمه عبور الزامی است";
        else if (password.length < 6) errors.password = "کلمه عبور حداقل ۶ کاراکتر باشد";

        if (password !== password2) errors.password2 = "کلمه عبور و تکرار آن یکسان نیستند";

        if (!firstName.trim()) errors.firstName = "نام الزامی است";
        if (!lastName.trim()) errors.lastName = "نام خانوادگی الزامی است";

        if (!phoneNumber.trim()) errors.phoneNumber = "شماره همراه الزامی است";
        else if (!/^09\d{9}$/.test(phoneNumber)) errors.phoneNumber = "شماره همراه معتبر نیست";

        if (!email.trim()) errors.email = "ایمیل الزامی است";
        else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) errors.email = "ایمیل معتبر نیست";

        if (!codeMelli.trim()) errors.codeMelli = "کد ملی الزامی است";
        else if (!/^\d{10}$/.test(codeMelli)) errors.codeMelli = "کد ملی باید ۱۰ رقم باشد";

        if (!jobs) errors.jobs = "شغل الزامی است";
        else if (jobs === "other" && !(jobsOther || "").trim()) errors.jobsOther = "لطفاً شغل خود را وارد کنید";

        if (!moassese) errors.moassese = "محل خدمت الزامی است";
        else if (moassese === "other" && !(moasseseOther || "").trim()) errors.moasseseOther = "لطفاً محل خدمت خود را وارد کنید";

        const hasError = Object.keys(errors).length > 0;

        this.setState({
            errors,
            generalError: hasError ? "خطاهای فرم را بررسی کنید" : "",
        });

        return !hasError;
    };

    scrollToFormTop = () => {
        setTimeout(() => {
            const el = document.getElementById("signup-form-top");
            if (el) {
                const y = el.getBoundingClientRect().top + window.pageYOffset - 200;
                window.scrollTo({ top: y, behavior: "smooth" });
            }
        }, 100);
    };

    handleSubmit = (e) => {
        e.preventDefault();

        this.setState({ generalError: "" });

        if (!this.validate()) {
            this.scrollToFormTop();
            return;
        }
        if (this.state.loading) return;

        this.setState({ loading: true });

        const {
            errors, generalError, loading, checkingAuth,
            jobsOther, moasseseOther, jobs, moassese,
            ...rest
        } = this.state;

        const payload = {
            ...rest,
            jobs,
            moassese,
            jobsOther: jobs === "other" ? jobsOther : "",
            moasseseOther: moassese === "other" ? moasseseOther : "",
        };

        axios.post(
            BASE_URL + "/api/v1/accounts/register/",
            payload,
            {
                timeout: TIMEOUT,
                headers: { "Content-Type": "application/json" },
            }
        ).then((response) => {
            const data = response.data;
            if (data.code === "success") {
                toastAlerts({ data: { code: "success", message: data.message } });
                this.context.fNavigate("/login");
            } else {
                if (data.errors) {
                    const flat = {};
                    Object.keys(data.errors).forEach((key) => {
                        flat[key] = Array.isArray(data.errors[key])
                            ? data.errors[key][0]
                            : data.errors[key];
                    });
                    this.setState({ errors: flat, generalError: "خطاهای فرم را بررسی کنید" });
                    this.scrollToFormTop();
                }
                toastAlerts(response);
            }
            this.setState({ loading: false });
        }).catch((error) => {
            const errData = error.response?.data;
            if (errData?.errors) {
                const flat = {};
                Object.keys(errData.errors).forEach((key) => {
                    flat[key] = Array.isArray(errData.errors[key])
                        ? errData.errors[key][0]
                        : errData.errors[key];
                });
                this.setState({ errors: flat, generalError: "خطاهای فرم را بررسی کنید" });
                this.scrollToFormTop();
            }
            toastAlerts(error.response);
            this.setState({ loading: false });
        });
    };

    render() {
        const {
            password, password2, firstName, lastName,
            phoneNumber, email, codeMelli,
            jobs, jobsOther, moassese, moasseseOther,
            website, errors, generalError, loading, checkingAuth,
        } = this.state;

        if (checkingAuth) {
            return (
                <HelmetProvider>
                    <Helmet>
                        <title>ثبت ‌نام دوره | مرکز ملی تحقیقات راهبردی آموزش علوم پزشکی (نصر)</title>
                    </Helmet>
                    {null}
                </HelmetProvider>
            );
        }

        return (
            <HelmetProvider>
                <Helmet>
                    <title>ثبت ‌نام دوره | مرکز ملی تحقیقات راهبردی آموزش علوم پزشکی (نصر)</title>
                    <link rel="canonical" href="https://nasrme.ac.ir" />
                </Helmet>

                <div className="container-fluid cFlex1 cBg3">
                    {header(this.context)}

                    <div className="row">
                        <div className="col-12 px-0">
                            <div className="login-page">

                                <div className="login-bg">
                                    <div className="login-bg-overlay" />
                                </div>

                                <div className="login-wrapper register-wrapper" id="signup-form-top">
                                    <div className="login-card">
                                        <div className="text-center mb-3">
                                            <img src="/images/logo.png" className="img-fluid w-50" alt="لوگو" />
                                        </div>

                                        <h1 className="login-title">ثبت ‌نام دوره</h1>
                                        <p className="login-subtitle">
                                            اطلاعات خود را وارد کنید
                                        </p>

                                        {generalError && (
                                            <div className="login-general-error">
                                                {generalError}
                                            </div>
                                        )}

                                        <form onSubmit={this.handleSubmit} className="login-form" noValidate>

                                            <div className="hp-field" aria-hidden="true">
                                                <label htmlFor="website">وب‌سایت</label>
                                                <input
                                                    id="website"
                                                    name="website"
                                                    type="text"
                                                    value={website}
                                                    onChange={this.handleChange}
                                                    tabIndex={-1}
                                                    autoComplete="off"
                                                />
                                            </div>

                                            <div className="login-field">
                                                <label htmlFor="password">کلمه عبور</label>
                                                <input
                                                    id="password"
                                                    name="password"
                                                    type="password"
                                                    value={password}
                                                    onChange={this.handleChange}
                                                    placeholder="کلمه عبور"
                                                    autoComplete="off"
                                                    disabled={loading}
                                                    className={errors.password ? "is-invalid" : ""}
                                                />
                                                {errors.password && (
                                                    <span className="login-field-error">{errors.password}</span>
                                                )}
                                            </div>

                                            <div className="login-field">
                                                <label htmlFor="password2">تکرار کلمه عبور</label>
                                                <input
                                                    id="password2"
                                                    name="password2"
                                                    type="password"
                                                    value={password2}
                                                    onChange={this.handleChange}
                                                    placeholder="تکرار کلمه عبور"
                                                    autoComplete="off"
                                                    disabled={loading}
                                                    className={errors.password2 ? "is-invalid" : ""}
                                                />
                                                {errors.password2 && (
                                                    <span className="login-field-error">{errors.password2}</span>
                                                )}
                                            </div>

                                            <div className="login-field">
                                                <label htmlFor="firstName">نام</label>
                                                <input
                                                    id="firstName"
                                                    name="firstName"
                                                    type="text"
                                                    value={firstName}
                                                    onChange={this.handleChange}
                                                    placeholder="نام"
                                                    disabled={loading}
                                                    className={errors.firstName ? "is-invalid" : ""}
                                                />
                                                {errors.firstName && (
                                                    <span className="login-field-error">{errors.firstName}</span>
                                                )}
                                            </div>

                                            <div className="login-field">
                                                <label htmlFor="lastName">نام خانوادگی</label>
                                                <input
                                                    id="lastName"
                                                    name="lastName"
                                                    type="text"
                                                    value={lastName}
                                                    onChange={this.handleChange}
                                                    placeholder="نام خانوادگی"
                                                    disabled={loading}
                                                    className={errors.lastName ? "is-invalid" : ""}
                                                />
                                                {errors.lastName && (
                                                    <span className="login-field-error">{errors.lastName}</span>
                                                )}
                                            </div>

                                            <div className="login-field">
                                                <label htmlFor="phoneNumber">شماره همراه</label>
                                                <input
                                                    id="phoneNumber"
                                                    name="phoneNumber"
                                                    type="text"
                                                    value={phoneNumber}
                                                    onChange={this.handleChange}
                                                    placeholder="شماره همراه خود را وارد کنید"
                                                    disabled={loading}
                                                    className={errors.phoneNumber ? "is-invalid" : ""}
                                                />
                                                {errors.phoneNumber && (
                                                    <span className="login-field-error">{errors.phoneNumber}</span>
                                                )}
                                            </div>

                                            <div className="login-field">
                                                <label htmlFor="email">ایمیل</label>
                                                <input
                                                    id="email"
                                                    name="email"
                                                    type="email"
                                                    value={email}
                                                    onChange={this.handleChange}
                                                    placeholder="example@mail.com"
                                                    disabled={loading}
                                                    className={errors.email ? "is-invalid" : ""}
                                                />
                                                {errors.email && (
                                                    <span className="login-field-error">{errors.email}</span>
                                                )}
                                            </div>

                                            <div className="login-field">
                                                <label htmlFor="codeMelli">کد ملی</label>
                                                <input
                                                    id="codeMelli"
                                                    name="codeMelli"
                                                    type="text"
                                                    value={codeMelli}
                                                    onChange={this.handleChange}
                                                    placeholder="۱۰ رقم"
                                                    disabled={loading}
                                                    className={errors.codeMelli ? "is-invalid" : ""}
                                                />
                                                {errors.codeMelli && (
                                                    <span className="login-field-error">{errors.codeMelli}</span>
                                                )}
                                            </div>

                                            <div className="login-field">
                                                <label>شغل</label>
                                                <SearchableSelect
                                                    name="jobs"
                                                    options={JOB_CHOICES}
                                                    value={jobs}
                                                    onChange={this.handleChange}
                                                    placeholder="انتخاب کنید"
                                                    isInvalid={!!errors.jobs}
                                                    isDisabled={loading}
                                                />
                                                {errors.jobs && (
                                                    <span className="login-field-error">{errors.jobs}</span>
                                                )}
                                            </div>

                                            {jobs === "other" && (
                                                <div className="login-field">
                                                    <label htmlFor="jobsOther">شغل خود را وارد کنید</label>
                                                    <input
                                                        id="jobsOther"
                                                        name="jobsOther"
                                                        type="text"
                                                        value={jobsOther}
                                                        onChange={this.handleChange}
                                                        placeholder="شغل"
                                                        disabled={loading}
                                                        className={errors.jobsOther ? "is-invalid" : ""}
                                                    />
                                                    {errors.jobsOther && (
                                                        <span className="login-field-error">{errors.jobsOther}</span>
                                                    )}
                                                </div>
                                            )}

                                            <div className="login-field">
                                                <label>محل خدمت</label>
                                                <SearchableSelect
                                                    name="moassese"
                                                    options={MOASSESE_CHOICES}
                                                    value={moassese}
                                                    onChange={this.handleChange}
                                                    placeholder="انتخاب کنید"
                                                    isInvalid={!!errors.moassese}
                                                    isDisabled={loading}
                                                />
                                                {errors.moassese && (
                                                    <span className="login-field-error">{errors.moassese}</span>
                                                )}
                                            </div>

                                            {moassese === "other" && (
                                                <div className="login-field">
                                                    <label htmlFor="moasseseOther">محل خدمت خود را وارد کنید</label>
                                                    <input
                                                        id="moasseseOther"
                                                        name="moasseseOther"
                                                        type="text"
                                                        value={moasseseOther}
                                                        onChange={this.handleChange}
                                                        placeholder="محل خدمت"
                                                        disabled={loading}
                                                        className={errors.moasseseOther ? "is-invalid" : ""}
                                                    />
                                                    {errors.moasseseOther && (
                                                        <span className="login-field-error">{errors.moasseseOther}</span>
                                                    )}
                                                </div>
                                            )}

                                            <div className="login-actions">
                                                <button
                                                    type="submit"
                                                    className="login-btn"
                                                    disabled={loading}
                                                >
                                                    ثبت ‌نام
                                                </button>
                                                <a
                                                    href="/login"
                                                    className="login-forgot"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        this.context.fNavigate("/login");
                                                    }}
                                                >
                                                    قبلاً ثبت‌ نام کرده‌اید؟ وارد شوید
                                                </a>
                                            </div>
                                        </form>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    {footer(true)}
                </div>
            </HelmetProvider>
        );
    }
}

export default withRouter(Signup);